<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">维修人员：</span>
        </div>
        <el-input v-model="formData.personName" disabled size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">维修类别：</span>
        </div>
        <el-select v-model="repairTypeCode" size="small" multiple style="width: 280px">
          <el-option v-for="item in repairCategoryList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import {getObjectURL} from '../../../utils/toBase64'
  import $ from 'jquery'
  import {api} from '../../api/RepairManagement'
  import {nError, nSuccess} from '../../../utils/notice'
  import {errorHandler} from '../../../utils/errorHandler'
  import UploadImgList from '../../../components/Input/UploadImgList'

  export default {
    components: {
      UploadImgList,
      ButtonCancel,
      ButtonConfirm,
      TextTitle,
      Breadcrumb},
    name: 'repair-person-modify',
    data () {
      return {
        breadcrumb: [{
          value: '智慧报修',
          name: 'repair-category-manage'
        }, {
          value: '维修人员管理'
        }],
        mainTitle: '修改维修人员',
        subheading: '',
        personList: [],
        repairCategoryList: [],

        repairTypeCode: [],

        formData: {
          code: '',
          personCode: '',
          personName: '',
          personPhone: '',
          repairTypeCode: '',
          repairTypeName: ''
        },
      }
    },
    created () {
      this.formData.code = this.$route.params.code
      this.formData.personCode = this.$route.params.personCode
      this.formData.personName = this.$route.params.personName
      this.formData.personPhone = this.$route.params.personPhone
      this.formData.repairTypeCode = this.$route.params.repairTypeCode
      this.formData.repairTypeName = this.$route.params.repairTypeName
      this.repairTypeCode = this.$route.params.repairTypeCode.split(',')
      this.getResponsiblePersonList()
      this.getRepairCategoryList()
    },
    methods: {
      // 获取人员列表
      getResponsiblePersonList () {
        this.$axios.post(api.getResponsiblePersonList, {})
          .then(res => {
            if (res.data.retCode === 1) {
              this.personList = res.data.data
            }
          })
          .catch(errorHandler('获取人员列表失败'))
      },
      // 获取维修类别
      getRepairCategoryList () {
        this.$axios.post(api.getRepairCategoryList, {})
          .then(res => {
            if (res.data.retCode === 1) {
              this.repairCategoryList = res.data.data
            }
          })
          .catch(errorHandler('获取维修列表失败'))
      },
      toRepairPersonManagePage () {
        this.$router.push({
          name: 'repair-person-manage'
        })
      },

      confirm () {
        if (!this.formData.personCode) {
          nError('请选择维修人员')
          return false
        }
        if (this.repairTypeCode.length === 0) {
          nError('请选择维修类别')
          return false
        }
        this.personList.map(v => {
          if (v.code === this.formData.personCode) {
            this.formData.personName = v.name
            this.formData.personPhone = v.phone
          }
        })
        let repairTypeCodeArr =  [], repairTypeNameArr = []
        this.repairCategoryList.map(v => {
          if (this.repairTypeCode.indexOf(v.code) !== -1) {
            repairTypeCodeArr.push(v.code)
            repairTypeNameArr.push(v.name)
          }
        })
        this.formData.repairTypeCode = repairTypeCodeArr.join(',')
        this.formData.repairTypeName = repairTypeNameArr.join(',')
        this.$axios.post(api.updateRepairMan, this.formData)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('修改成功')
              this.toRepairPersonManagePage()
            }
          })
          .catch(errorHandler('修改失败'))
      },
      cancel () {
        this.toRepairPersonManagePage()
      }
    }
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
    vertical-align: sub;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
  }
  .form-line>div {
    margin-right: 20px;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 122px;
    line-height: 32px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 110px 0 140px;
    margin: 40px 0 0 0;
    display: flex;
    justify-content: space-between;
  }
  .newly2 {
    display: inline-block;
    width: 250px;
    height: 173px;
    vertical-align: text-top;
    border: 1px dashed #D7D7D7;
    margin-right: 20px;
    position: relative;
  }
  .newly2 span {
    display: block;
    width: 100%;
    color: #999999;
    margin: 0;
    padding: 0;
    text-align: center;
  }
  .newly2 span:first-child {
    font-size: 36px;
    line-height: 120px;
    position: absolute;
    top: 15px;
  }
  .newly2 span:last-child {
    font-size: 14px;
    line-height: 50px;
    position: absolute;
    bottom: 0;
  }
  .upload2 {
    display: inline-block;
    width: 250px;
    height: 173px;
    vertical-align: text-top;
    background-size: 100% 100%;
    position: relative;
  }

  .upload2 img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }
  .upload2 b {
    display: inline-block;
    width: 100%;
    line-height: 21px;
    color: white;
    background-color: #989796;
    text-align: center;
    position: absolute;
    bottom: 0;
    opacity: .7;
  }
</style>

<style lang="less">
  .el-switch {
    height: 30px;
  }
</style>




// WEBPACK FOOTER //
// src/view/RepairManagement/repairPerson/repairPersonModify.vue